require('./screenshare-toolbar-template.html');
require('./toolbar.style.less');

var module = angular.module('bbl.module.view-screenshare');

module.directive('toolbar', [function() {
  return {
    templateUrl: 'screenshare-toolbar-template.html',
    restrict: 'EA',
    link: function($scope) {
      $scope.isFsCentral = function() {
        return $scope.bridge.jfb_url.match(/fs\-central/i);
      };
    }
  };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/view-screenshare/toolbar/index.js
 ** module id = 393
 ** module chunks = 0
 **/